module.exports = __webpack_public_path__ + "img/emoji_039.e7001488.png";